var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenIconOutlineGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.77246H10",
    stroke: "#B4B1B1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.7725H7",
    stroke: "#B4B1B1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4282 18.3446L20.5 11.2728C21.6046 10.1682 21.6046 8.37733 20.5 7.27276C19.3954 6.16819 17.6046 6.16819 16.5 7.27276L9.42819 14.3446C9.14899 14.6238 8.95868 14.9794 8.88124 15.3666L8 19.7728L12.4062 18.8916C12.7934 18.8141 13.149 18.6238 13.4282 18.3446Z",
    stroke: "#B4B1B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIconOutlineGray);
export default __webpack_public_path__ + "static/media/PenIconOutlineGray.f48de362c41951ac52e4cfdc75439412.svg";
export { ForwardRef as ReactComponent };